// Categorías de juego. El `value` es lo que se persiste (board_game.category y
// used_game.category, ambas INT) y el `label` es el nombre que muestra la tienda
// (getCategoryName en frontend/src/services/mappers/productMappers.ts).
//
// Vive acá y no duplicado en cada form a propósito: este vocabulario ya estuvo
// desalineado entre el backoffice, el landing y el storefront, y el resultado fue
// que un juego cargado como "Abstracto" se le mostraba al cliente como "Infantil".
// Si se agrega una categoría, se agrega ACÁ y también en el mapa del storefront.
export const GAME_CATEGORIES = [
    { value: 1, label: 'Euro' },
    { value: 2, label: 'Party' },
    { value: 3, label: 'Familiar' },
    { value: 4, label: 'Abstracto' },
    { value: 5, label: 'Temático' },
    { value: 6, label: 'Investigación' },
];

const CATEGORY_LABELS = GAME_CATEGORIES.reduce((map, c) => { map[c.value] = c.label; return map; }, {});

export function categoryLabel(value) {
    if (value == null || value === '') {
        return 'Sin especificar';
    }

    return CATEGORY_LABELS[Number(value)] || `Categoría ${value} (fuera de lista)`;
}

// True si el valor NO pertenece al vocabulario (pero tampoco está vacío).
// `used_game.category` se cargó durante un tiempo con un input numérico libre, así
// que puede haber filas con valores que no están en la lista. Los forms las muestran
// como una opción extra para no reescribirlas en silencio al guardar.
export function isOutOfVocabulary(value) {
    return value != null && value !== '' && CATEGORY_LABELS[Number(value)] == null;
}
